<template>
  <div>
    <DataTableComponent :table="table"></DataTableComponent>
  </div>
</template>

<script>
import DataTableComponent from "../../components/DataTableComponent";
export default {
  data() {
    return {
      table: {
        modal: "Grade",
        path: "grades",
        headers: [
          {
            text: this.$i18n.t("Name"),
            value: "grade_name",
          },
          {
            text: this.$i18n.t("Arabic Name"),
            value: "ar_grade_name",
          },
          {
            text: this.$i18n.t("Short Name"),
            value: "short_name",
          },
          {
            text: this.$i18n.t("Color"),
            value: "color_hex",
          },
          {
            text: this.$i18n.t("Actions"),
            value: "actions",
            sortable: false,
            width: "12%",
          },
        ],
        title: this.$i18n.t("Grades"),
        apiEndPoints: {
          list: "grades",
          create: "grades/store",
          edit: "grades/update",
          delete: "grades/destroy",
        },
        editedItem: {
          grade_name: "",
          short_name: "",
          ar_grade_name: "",
        },
        permissions: {
          list: "list-grades",
          add: "add-grades",
          edit: "edit-grades",
          delete: "delete-grades",
          import: "import-grades",
        },
      },
    };
  },
  methods: {},
  components: {
    DataTableComponent,
  },
  mounted() {},
};
</script>

<style></style>
